import { makeAutoObservable } from 'mobx';
import { groupByFunction } from './utils/rxjs/groupByFunction';

export class ApiCallsStore {
  root;
  callsRemaining = 1000;
  apiCallsSubject;

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStream();
  }

  initializeStream = () => {
    this.apiCallsSubject = groupByFunction(
      'messageType',
      'apiCalls',
      this.root.websocketSubject
    ).subscribe((msg) => this.setCallsRemaining(msg.callsRemaining));
  };

  setCallsRemaining = (callsRemaining) => (this.callsRemaining = callsRemaining);
}
